export const isPayPalEnabled = (enabledAt, property) => {
  if (enabledAt) {
    var list = enabledAt.split(',');
    return list.includes(property);
  }
};
